export function DtoReqUpdatePassword() {
    return {
        clave: "",
        claveAnterior: "",
    }
}